import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LetterSurveyNewBadgeComponent } from './letter-survey-new-badge.component';

@NgModule({
  declarations: [LetterSurveyNewBadgeComponent],
  imports: [
    CommonModule
  ],
  exports: [LetterSurveyNewBadgeComponent],
})
export class LetterSurveyNewBadgeModule { }
